import React, { useState, useCallback } from 'react';
import Container from '@Theme/natucare/components/Container/Container';
import Button from '@Theme/natucare/components/Button/Button';
import Item from './components/Item/Item';
import { blogPropTypes } from './BlogPropTypes';
import * as styles from './Blog.module.scss';
const Blog = ({
  subheading,
  heading,
  text,
  tabs
}) => {
  if (!heading && !tabs) {
    return null;
  }
  const {
    0: selectedTabIndex,
    1: setSelectedTabIndex
  } = useState(0);
  const handleOnClick = useCallback(index => {
    setSelectedTabIndex(index);
  }, [setSelectedTabIndex]);
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${styles.rootWave} ${styles.rootBeige}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, subheading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootSubheading
  }, subheading), heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), text && /*#__PURE__*/React.createElement("div", {
    className: styles.rootText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootTabs
  }, tabs.map(({
    label
  }, index) => /*#__PURE__*/React.createElement("span", {
    onClick: handleOnClick.bind(this, index),
    key: index,
    className: `${styles.rootTab} 
          ${index === selectedTabIndex ? styles.rootTabActive : ''}`
  }, label))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootItems
  }, tabs[selectedTabIndex].items.map((item, index) => /*#__PURE__*/React.createElement(Item, Object.assign({
    key: index
  }, item, {
    isActive: true
  })))), /*#__PURE__*/React.createElement("div", {
    class: styles.rootButtons
  }, tabs.map(({
    actions
  }, index) => {
    var _actions$button, _actions$button2;
    return actions ? /*#__PURE__*/React.createElement(Button, {
      classname: `${styles.rootButton} ${index === selectedTabIndex ? styles.rootButtonActive : ''}`,
      variant: "secondaryOrange",
      href: actions === null || actions === void 0 ? void 0 : (_actions$button = actions.button) === null || _actions$button === void 0 ? void 0 : _actions$button.href,
      label: actions === null || actions === void 0 ? void 0 : (_actions$button2 = actions.button) === null || _actions$button2 === void 0 ? void 0 : _actions$button2.label
    }) : '';
  }))));
};
export default Blog;